import { BusinessDestinationInfo } from "./BusinessDestinationInfo";
import { BusinessRequesterInfo, createDefaultRequester } from "./BusinessRequesterInfo";
import { Port, createEmptyPort } from "../FlightInformation/Port"
import { GoodsInfo } from "../GoodsInformation";
import { DestinationInfo, createDefaultDestination } from "./DestinationInfo";
import { OrderStatus } from "./OrderStatus";
import { PickupLocationInfo } from "./PickupLocationInfo";
import { ReceiveStatus } from "./ReceiveStatus";
import { RequesterInfo } from "./RequesterInfo";

/**
 * 配送情報
 */
export interface OrderInfo {
    /**
     * 注文番号
     */
    orderID: string,
    /**
     * ビジネスパートナーID
     */
    businessPartnerId: string,
    /**
     * 外部ID
     */
    externalOrderID?: string,
    /**
     * 注文日
     */
    orderDate: string,
    /**
     * 配送希望日時
     */
    preferredDeliveryDate: string,
    /**
     * 配送希望日時
     */
    preferredDeliveryTime: string,
    /**
     * 出発ポート
     */
    departure: Port,
    /**
     * 到着ポート
     */
    arrival: Port,
    /**
     * 配送物情報
     */
    goods: Array<GoodsInfo>,

    /**
     *　重心位置（東京都実証だけの対応）
     */
    positionCenterGravity?: {
        x: number,
        y: number,
        z: number
    },
    /**
     * カスタム重量
     * goodsに重量が設定されなかった場合
     */
    customWeight?: number,
    /**
     * 配送先情報
     */
    destination: DestinationInfo | BusinessDestinationInfo,
    /**
     * 配送依頼をした団体の情報（セブンとかアインとか）
     */
    requester: RequesterInfo | BusinessRequesterInfo
    /**
     * 配送依頼のステータス
     */
    status: OrderStatus,
    /**
     * 配送物の受け取り状態
     */
    receiveStatus: ReceiveStatus,
    /**
     * 備考
     */
    remarks: string,
    /**
     * 受け取り場所情報
     */
    pickupLocationInfo?: PickupLocationInfo,
    /**
     * 注文情報確認用のレシート画像のファイル名
     */
    receiptFileName?: string
}

/**
 * 初期データ作成
 * @deprecated
 */
export function createInitData(): OrderInfo {
    const order: OrderInfo = {
        orderID: "",
        businessPartnerId: "",
        orderDate: "",
        preferredDeliveryDate: "",
        preferredDeliveryTime: "",
        remarks: "",
        status: OrderStatus.Accepting,
        goods: new Array<GoodsInfo>(),
        departure: createEmptyPort(),
        arrival: createEmptyPort(),
        receiveStatus: ReceiveStatus.NotReceived,
        requester: createDefaultRequester(),
        destination: createDefaultDestination(),
    }
    return order;
}

export function parseOrderInfo(order: any): OrderInfo {
    const result = order as OrderInfo;
    return result;
}